<template>
  <div>
    <!-- 新增按钮 -->
    <Card style="margin-bottom: 10px">
      <div>
        <span>总充值金额: {{ totalAmount }}，</span>
        <span>总充值人数: {{ totalUserCount }}，</span>
        <span>总充值笔数: {{ totalCount }}，</span>
        <span>总周卡购买人数: {{ totalWeekCount }}，</span>
        <span>总月卡购买人数: {{ totalMonthCount }}，</span>
        <span>总新用户充值金额: {{ totalNewUserAmount }}</span>
      </div>
    </Card>

    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
      :options="options3"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
import { getCensusData } from "../../api/user";

export default {
  components: {},
  data() {
    return {
      selUser: {},
      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      isfengjin: false,

      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      lianxu: "",
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "日期",
          key: "createtime",
        },
        {
          title: "充值金额",
          key: "totalRecharge",
        },
        {
          title: "充值人数",
          key: "rechargeUserCount",
        },

        {
          title: "充值笔数",
          key: "dailyRechargeCount",
        },
        {
          title: "周卡购买人数",
          key: "weekRechargeCount",
        },
        {
          title: "月卡购买人数",
          key: "monthRechargeCount",
        },
        {
          title: "新用户充值金额",
          key: "newUserRechargeAmount",
        },
        {
          title: "日均充值金额",
          key: "dailyAverageRechargeAmount",
        },
        {
          title: "新用户付费转化率",
          key: "newPayingUsersRate",
        },
        {
          title: "arpu",
          key: "arpustr",
        },
        {
          title: "pur",
          key: "purstr",
        },
      ],

      current: 1,
      total: 0,
      options3: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 将时间设置为当天的开始
          return date && date.getTime() > today.getTime() - 1;
        },
      },
      totalAmount: 0,
      totalUserCount: 0,
      totalCount: 0,
      totalWeekCount: 0,
      totalMonthCount: 0,
      totalNewUserAmount: 0,
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    close() {
      this.visible = false;
    },
    // disabledDate(date) {
    //   // 禁止选择今天及以后的日期

    // },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      getCensusData(params)
        .then((response) => {
          this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.totalPages; // 获取总数
          // 计算总和
          this.calculateTotals();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 计算总和的方法
    calculateTotals() {
      this.totalAmount = this.data9.reduce((sum, item) => sum + (Number(item.totalRecharge) || 0), 0).toFixed(2);
      this.totalUserCount = this.data9.reduce((sum, item) => sum + (Number(item.rechargeUserCount) || 0), 0);
      this.totalCount = this.data9.reduce((sum, item) => sum + (Number(item.dailyRechargeCount) || 0), 0);
      this.totalWeekCount = this.data9.reduce((sum, item) => sum + (Number(item.weekRechargeCount) || 0), 0);
      this.totalMonthCount = this.data9.reduce((sum, item) => sum + (Number(item.monthRechargeCount) || 0), 0);
      this.totalNewUserAmount = this.data9.reduce((sum, item) => sum + (Number(item.newUserRechargeAmount) || 0), 0).toFixed(2);
    },

    // 查询商品
    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        starttime,
        endtime,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
  },
};
</script>
